import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Navbar, Container, Nav, Offcanvas } from 'react-bootstrap';
import Cookies from "js-cookie";
import { ReactComponent as AppIcon } from '../assets/app-icon-small.svg';

export default function Header({setLang, lang}) {
    const [show, setShow] = useState(false);
    
    const languages = {
        en: 'en',
        hi: 'hi',
    };
    
    const {en, hi} = languages;

    const handleLanguage = (lang) => {
        Cookies.set('tmpl_lang', lang);
        setLang(lang);
        setShow(false); // Close mobile menu
    };

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <Navbar className="header-navbar shadow-sm" expand="lg" variant="light">
            <Container fluid>
                <Navbar.Brand as={Link} to="/" className="brand-title d-flex align-items-center">
                    <AppIcon className="me-2" width="32" height="32" />
                    Numerology
                </Navbar.Brand>
                
                <Navbar.Toggle 
                    aria-controls="offcanvasNavbar" 
                    onClick={handleShow}
                />
                
                <Navbar.Offcanvas
                    id="offcanvasNavbar"
                    aria-labelledby="offcanvasNavbarLabel"
                    placement="end"
                    show={show}
                    onHide={handleClose}
                >
                    <Offcanvas.Header closeButton>
                        <Offcanvas.Title id="offcanvasNavbarLabel" className="d-flex align-items-center">
                            <AppIcon className="me-2" width="24" height="24" />
                            Numerology
                        </Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                        <Nav className="justify-content-end flex-grow-1 pe-3">
                            <NavLink 
                                to="/" 
                                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                                onClick={handleClose}
                            >
                                🏠 Home
                            </NavLink>
                            <NavLink 
                                to="/compatibility" 
                                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                                onClick={handleClose}
                            >
                                💕 SoulSync
                            </NavLink>
                            <hr className="d-lg-none" />
                            <div className="d-flex gap-2 mt-2 mt-lg-0">
                                <button 
                                    className={`btn btn-sm ${lang === en ? 'btn-primary' : 'btn-outline-primary'}`}
                                    disabled={lang === en} 
                                    onClick={() => handleLanguage(en)}
                                >
                                    EN
                                </button>
                                <button 
                                    className={`btn btn-sm ${lang === hi ? 'btn-primary' : 'btn-outline-primary'}`}
                                    disabled={lang === hi} 
                                    onClick={() => handleLanguage(hi)}
                                >
                                    हिंदी
                                </button>
                            </div>
                        </Nav>
                    </Offcanvas.Body>
                </Navbar.Offcanvas>
            </Container>
        </Navbar>
    );
}
